import { render, staticRenderFns } from "./BuyedOrderModal.vue?vue&type=template&id=03e812ac&"
import script from "./BuyedOrderModal.vue?vue&type=script&lang=js&"
export * from "./BuyedOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyedOrderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports